import {
	CAN_CONTRIBUTE,
	PROJECT_ROLES_ARR_BY_STRENGTH,
	PROJECTS_PERSONAL_ACCESS_TYPE,
	PROJECTS_WORKSPACE_ACCESS_TYPE,
} from '@/utils/projects.const';

const isProjectOwner = (project, user_id) => Number(project?.owner) === Number(user_id);

const isPersonalProject = (project) => project?.access_type === PROJECTS_PERSONAL_ACCESS_TYPE;
const isMyPersonalProject = (project, user) => project?.access_type === PROJECTS_PERSONAL_ACCESS_TYPE && project.owner === user.id;
const isWorkspaceProject = (project) => project?.access_type === PROJECTS_WORKSPACE_ACCESS_TYPE;

const getFirstPersonalProject = (projects) => projects.find((x) => isPersonalProject(x));
const isSpaceWithoutAccess = (project) => project && [false, null].includes(project.has_direct_access);
const canSpaceMemberRunFeature = (memberRole) => {
	const minimumRoleIndex = PROJECT_ROLES_ARR_BY_STRENGTH.findIndex((role) => role === CAN_CONTRIBUTE);
	const roleIndex = PROJECT_ROLES_ARR_BY_STRENGTH.findIndex((role) => role === memberRole);
	return roleIndex >= minimumRoleIndex;
};

const getFilteredProjectsList = (projects, filterOutIds, filterInIds) => {
	if (filterInIds && filterOutIds) {
		throw new Error('decide what do to, filter in or filter out');
	}

	if (filterOutIds) {
		return projects.filter((x) => !filterOutIds.includes(x.id));
	}
	if (filterInIds) {
		return projects.filter((x) => filterInIds.includes(x.id));
	}
	return projects;
};

const ProjectsService = {
	isProjectOwner,
	isMyPersonalProject,
	isPersonalProject,
	isWorkspaceProject,
	isSpaceWithoutAccess,
	getFirstPersonalProject,
	getFilteredProjectsList,
	canSpaceMemberRunFeature,
};

export default ProjectsService;
